import PropTypes from 'prop-types';
import React, { Component } from 'react';

export default class CodeSplitComponentInner extends Component {
  static propTypes = {
    component: PropTypes.func.isRequired,
  };

  render() {
    const { component, ...passThroughProps } = this.props;
    const PassedComponent = component;
    return <PassedComponent {...passThroughProps} />;
  }
}
